/**
 * Shared hook to open the New Message modal with pre-filled recipient from conversation context.
 * Used by ChatBox and ConversationHeader to avoid duplicating callback logic.
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { MODAL_NEW_MESSAGE } from '@/components/organisms/Modals/ModalConductor';
import { pushModal } from '@/redux/modals/actions';
import { Conversation } from '@/shared/types/chat';

interface UseOpenNewMessageModalOptions {
  conversation: Conversation | null | undefined;
}

export const useOpenNewMessageModal = ({ conversation }: UseOpenNewMessageModalOptions) => {
  const dispatch = useDispatch();

  const openNewMessageModal = useCallback(() => {
    // Get the user's contact info from conversation context (phone or email)
    const userContext = conversation?.context?.user;
    const initialTo = userContext?.phone || userContext?.email || '';
    const initialIntegrationId = conversation?.integration_id || '';

    dispatch(pushModal(MODAL_NEW_MESSAGE, { initialTo, initialIntegrationId }));
  }, [conversation?.context?.user, conversation?.integration_id, dispatch]);

  return { openNewMessageModal };
};
